import { Modal, Typography } from "antd";
import React from "react";
import { assertNever } from "utils/assert";

import { CreateMonitorModalContent } from "./CreateMonitorModalContent";
import { EditMonitorForm } from "./EditMonitorForm";
import { SaveSearchForm } from "./SaveSearchForm";
import { MonitorModalProps } from "./types";

export const MonitorModal: React.FC<MonitorModalProps> = (props) => {
  const { mode, onCancel, open, ...rest } = props;

  const modalTitle =
    mode === "edit-monitor"
      ? "Edit Monitor"
      : mode === "create-monitor"
        ? "Create New Monitor"
        : "Save This Search";

  switch (props.mode) {
    case "edit-monitor":
      return (
        <Modal footer={false} onCancel={onCancel} open={open} {...rest}>
          <Typography.Title level={4}>{modalTitle}</Typography.Title>
          <EditMonitorForm
            isCustom={props.isCustom}
            monitor={props.monitor}
            onSubmitForm={props.onCancel}
            show={props.monitor?.show ?? "grant"}
          />
        </Modal>
      );

    case "create-monitor":
      return <CreateMonitorModalContent {...props} modalProps={rest} />;

    case "save-search":
      return (
        <Modal footer={false} onCancel={onCancel} open={open} {...rest}>
          <Typography.Title level={4}>{modalTitle}</Typography.Title>
          <SaveSearchForm
            initialSearchTerm={props.initialSearchTerm}
            show={props.show}
            onCancel={props.onCancel}
            onSaveSearch={props.onSaveSearch}
            allowTemplateSelection={props.allowTemplateSelection}
            startWithTemplate={props.startWithTemplate}
          />
        </Modal>
      );

    default: {
      assertNever(props);
      return null;
    }
  }
};
